import React from 'react';
import { useNavigate } from 'react-router-dom';
import { event } from '../utils/gtm';

const UpgradeError = ({ message, source }) => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    event({ action: 'click_upgrade_intent', category: 'Monetization', label: `Source: Out of Credits - ${source}` });
    navigate('/pricing');
  };

  return (
    <div className="bg-red-900/30 border border-red-700 text-white rounded-lg p-6 mt-5 text-center">
      <h3 className="text-lg font-bold text-red-200 mb-2">You're Out of Credits!</h3>
      <p className="text-sm mb-4">{message}</p>
      <p className="text-sm text-red-200 mb-4">You can get more credits immediately by upgrading or purchasing a credit pack.</p>
      <div className="flex justify-center gap-4">
        <button onClick={handleUpgradeClick} className="flex-1 rounded-full bg-gradient-to-r from-[#1d94d0] to-[#1E3A8A] px-5 py-2 text-sm font-semibold text-white transition-all duration-300 hover:shadow-lg hover:shadow-[#1d94d0]/40 hover:brightness-110">
          Upgrade to Pro
        </button>
        <button onClick={handleUpgradeClick} className="flex-1 rounded-full bg-gray-600 hover:bg-gray-500 px-5 py-2 text-sm font-semibold text-white transition-colors duration-300">
          Buy Credits
        </button>
      </div>
    </div>
  );
};

export default UpgradeError;